/**
 * This function prevents the page jump
 * links in the montior description from interfearing with therouter
 *
 */
function beforeRouteLeave(to, from, next) {
  const notRoutes = ['macro', 'market', 'credit', 'solvency', 'funding', 'contagion'];
  if (notRoutes.indexOf(to.name) >= 0) {
    this.$router.push(this.$route.path);
  } else if (to.name === 'categories') {
    window.scrollTo(0, 818);
    next();
  } else {
    next();
  }
}

export default beforeRouteLeave;



// WEBPACK FOOTER //
// ./src/helpers/navHelpers.js